export * from './sidebar.directive';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/directives/sidebar/index.ts